import { selectAccountId } from 'affiny-core/redux/selectors/accountSelectors';
import { call, select } from 'redux-saga/effects';
import {
  IMatchListQueryParams,
  MatchlistResource,
} from '../../core/resources/matchlist.resource';
import { matchListNormalizer } from './matchList.normalizer';

export function* getMatchList(
  pageNumber = 1,
  queryParams?: IMatchListQueryParams
) {
  const accountId = yield select(selectAccountId);

  const response = yield call(
    MatchlistResource.getMatchlistByAccountId,
    accountId,
    {
      pageNumber,
      sortType: queryParams && queryParams.sortType,
      subScore: queryParams && queryParams.subScore,
      excludedMembers: queryParams && queryParams.excludedMembers,
    }
  );

  return matchListNormalizer(response);
}
